import { useUnit } from "effector-react";
import { useEffect } from "react";
import { $termsStore, fetchAllTerms } from "../store";

export const useTermsViewModel = () => {
  const store = useUnit($termsStore);
  const fetch = useUnit(fetchAllTerms);

  useEffect(() => {
    // Fetch terms only if they haven't been initialized yet.
    if (!store.initialized && !store.loading) {
      fetch();
    }
  }, [store.initialized, store.loading, fetch]);

  return store;
};